"use client";
import {
  RadialBarChart,
  RadialBar,
  PolarRadiusAxis,
  Label,
  Tooltip,
} from "recharts";

const chartData = [
  {
    month: "january",
    desktop: 1260,
    mobile: 570,
    tablet: 320,
  },
];

export default function TestChart() {
  // حساب الإجمالي كما هو معمول في المثال
  const total =
    chartData[0].desktop + chartData[0].mobile + chartData[0].tablet;

  return (
    <div style={{ width: 500, height: 200 }}>
      <RadialBarChart
        width={400}
        height={400}
        innerRadius={100} // زيادة السماكة
        outerRadius={180}
        data={chartData}
        endAngle={180}
      >
        <PolarRadiusAxis tick={false} axisLine={false}>
          <Label
            position="center"
            content={({ viewBox }) => (
              <text x={viewBox.cx} y={viewBox.cy} textAnchor="middle">
                {/* هنا يمكنك تغيير الرقم المعروض */}

                   <tspan
                  x={viewBox.cx}
                  y={viewBox.cy + 15}
                  fontSize="14"
                  fill="#999"
                >
                  Social Media
                </tspan>
                <tspan
                  x={viewBox.cx}
                  y={viewBox.cy - 10}
                  fontSize="22"
                  fontWeight="bold"
                >
                58%
                </tspan>
             
              </text>
            )}
          />
        </PolarRadiusAxis>

        <RadialBar
          dataKey="desktop"
          fill="#223160"
          cornerRadius={5}
          stackId="a"
        />
        <RadialBar
          dataKey="mobile"
          fill="#e9e7fd"
          cornerRadius={5}
          stackId="a"
        />
        <RadialBar
          dataKey="tablet"
          fill="#cccccc"
          cornerRadius={5}
          stackId="a"
        />
        <Tooltip />
      </RadialBarChart>
    </div>
  );
}
